import React from 'react';

import {
  offersHubPayloadDownloadFilename,
  serializeOffersHubPayload,
  serializeOffersHubPreviewPayload,
} from '~/utils/societePayloadBuilder/offersHub/buildPayload';
import { createDefaultOffersHubState } from '~/utils/societePayloadBuilder/offersHub/defaults';
import { hasOffersHubProgress } from '~/utils/societePayloadBuilder/offersHub/hasProgress';
import { parseOffersHubPayload } from '~/utils/societePayloadBuilder/offersHub/parsePayload';
import type { OffersHubPayloadBuilderState } from '~/utils/societePayloadBuilder/offersHub/types';
import { validateOffersHubPayload } from '~/utils/societePayloadBuilder/offersHub/validatePayload';

import PayloadBuilderJsonPreview from '../JsonPreview';
import StandalonePayloadActions from '../StandalonePayloadActions';
import StandalonePayloadBuilderPage from '../StandalonePayloadBuilderPage';

import OffersHubPayloadBuilderForm from './OffersHubPayloadBuilderForm';

interface OffersHubPayloadBuilderPageProps {
  onProgressChange?: (hasProgress: boolean) => void;
}

export default function OffersHubPayloadBuilderPage({ onProgressChange }: OffersHubPayloadBuilderPageProps) {
  return (
    <StandalonePayloadBuilderPage<OffersHubPayloadBuilderState>
      onProgressChange={onProgressChange}
      createDefaultState={createDefaultOffersHubState}
      hasProgress={hasOffersHubProgress}
      parsePayload={parseOffersHubPayload}
      validate={validateOffersHubPayload}
      renderActions={(state, isValid, fullWidth) => (
        <StandalonePayloadActions
          state={state}
          isValid={isValid}
          fullWidth={fullWidth}
          serialize={serializeOffersHubPayload}
          getFilename={offersHubPayloadDownloadFilename}
          payloadName="Offers Hub"
        />
      )}
      renderForm={(props) => <OffersHubPayloadBuilderForm {...props} />}
      renderPreview={(state, borderSoft, maxHeight) => (
        <PayloadBuilderJsonPreview
          state={state}
          serialize={serializeOffersHubPreviewPayload}
          borderSoft={borderSoft}
          maxHeight={maxHeight}
        />
      )}
    />
  );
}
